"use strict";

class StationSettingsEpgStartTimesCtrl {

    constructor($rootScope, $http, $mdToast, $scope, $cacheFactory)
    {
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;

        this.$httpCache = $cacheFactory.get('$http');

        this.settings = {
            broadcast_default_published: "yes"
        };

        this.fetch();

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        $scope.$watch(() => {
            return $scope.timesettings.$invalid;
        },(newVal) => {
            $rootScope.saveDisabled = newVal;
        });

    }

    save() {
        this.$rootScope.saveDisabled = true;
        let data = this.settings;
        angular.forEach(data.epg_start, function (time, day) {
            if(time === undefined && day != "start_day_of_week"){
                console.log(day+' is undefined!');
                data.epg_start[day] = "06:00"
            }
        });

        //force start_day_of_week as integer!
        data.epg_start.start_day_of_week = parseInt(data.epg_start.start_day_of_week);
        
        this.$http.put('/stationsettings/settings', data)
            .then(() => {

                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.object_saved?object=Epg_start_times',
                    hideDelay: 6000,
                    position: ('top right')
                });
                this.$rootScope.saveDisabled = false;

                this.$httpCache.removeAll();
            });
    }

    fetch() {
        this.$http.get('/stationsettings/settings').then(response => {
            // this.settings = response.data;
            angular.merge(this.settings, response.data);
        });
    }
}

StationSettingsEpgStartTimesCtrl.$inject = [
    '$rootScope',
    '$http',
    '$mdToast',
    '$scope',
    '$cacheFactory'
];

module.exports = StationSettingsEpgStartTimesCtrl;